export interface PluginCommandDefinition {
  command: string; // e.g. "/standup", "/blocker", "/sprint", "/export-vault"
  description: string;
  pluginId: string;
  execute: (args: string[]) => Promise<string | Record<string, unknown>>;
}

export class PluginCommandRegistry {
  private commands = new Map<string, PluginCommandDefinition>();

  constructor() {
    this.registerDefaultCommands();
  }

  private registerDefaultCommands(): void {
    this.registerCommand({
      command: '/standup',
      description: 'Record or view daily team standup summary',
      pluginId: 'scrum-master-workflow',
      execute: async () => 'Standup summary command executed.',
    });

    this.registerCommand({
      command: '/blocker',
      description: 'Flag a blocker and propose a Kanban blocker task',
      pluginId: 'scrum-master-workflow',
      execute: async () => 'Blocker command executed.',
    });

    this.registerCommand({
      command: '/sprint',
      description: 'Display current sprint progress and completion metrics',
      pluginId: 'scrum-master-workflow',
      execute: async () => 'Sprint metrics command executed.',
    });
  }

  registerCommand(def: PluginCommandDefinition): void {
    this.commands.set(def.command.toLowerCase(), def);
  }

  getCommand(command: string): PluginCommandDefinition | undefined {
    return this.commands.get(command.toLowerCase());
  }

  listCommands(): PluginCommandDefinition[] {
    return Array.from(this.commands.values());
  }

  async executeCommand(commandStr: string): Promise<string | Record<string, unknown>> {
    const parts = commandStr.trim().split(/\s+/);
    const cmd = parts[0]?.toLowerCase();
    if (!cmd) throw new Error('Empty command string');

    const def = this.commands.get(cmd);
    if (!def) throw new Error(`Command ${cmd} is not registered`);

    return def.execute(parts.slice(1));
  }
}

export const globalCommandRegistry = new PluginCommandRegistry();
